export const PLATFORM_NAME = '江苏省突发生态环境事件智慧应急系统（测试版）'
export const PLATFORM_SHORT_NAME = '江苏智慧应急系统（测试版）'

const LEGACY_PLATFORM_NAMES = new Set([
  '江苏省突发生态环境事件智能辅助决策系统',
  '江苏省突发生态环境事件智能辅助决策系统（测试版）',
  '江苏省突发生态环境事件 AI智能辅助决策系统',
  '江苏省突发生态环境事件应对工程技术中心 AI智能辅助支撑平台',
  '江苏省突发生态环境事件应对工程技术中心 AI智能辅助支撑系统',
  '江苏省突发生态环境事件应对工程技术中心智能辅助支撑系统'
])

const LEGACY_PLATFORM_SHORT_NAMES = new Set([
  '江苏应急平台',
  '江苏应急AI系统',
  '江苏应急AI系统（测试版）'
])

export const getPlatformName = () => {
  const name = String(process.env.VUE_APP_PLATFORM_NAME || '').trim()
  return !name || LEGACY_PLATFORM_NAMES.has(name) ? PLATFORM_NAME : name
}

export const getPlatformShortName = () => {
  const shortName = String(process.env.VUE_APP_PLATFORM_SHORT_NAME || '').trim()
  return !shortName || LEGACY_PLATFORM_SHORT_NAMES.has(shortName)
    ? PLATFORM_SHORT_NAME
    : shortName
}

export const getPlatformBranding = () => ({
  name: getPlatformName(),
  shortName: getPlatformShortName()
})
